import { render, staticRenderFns } from "./InvoicesMenu.vue?vue&type=template&id=09ea0e7a&"
import script from "./InvoicesMenu.vue?vue&type=script&lang=js&"
export * from "./InvoicesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ea0e7a')) {
      api.createRecord('09ea0e7a', component.options)
    } else {
      api.reload('09ea0e7a', component.options)
    }
    module.hot.accept("./InvoicesMenu.vue?vue&type=template&id=09ea0e7a&", function () {
      api.rerender('09ea0e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Extra/InvoicesMenu.vue"
export default component.exports